document.querySelector('.readmore').addEventListener('click', function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'block';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'none';
});

document.querySelector('.readless').addEventListener('click', function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'none';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'block';
  window.scrollTo({ top: 110, behavior: 'smooth' });
});

document.addEventListener('DOMContentLoaded', function () {
  const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
  const submitButton = document.querySelector('.product-form__single-submit');

  function toggleSubmitButton() {
    if (sellingPlanInput && sellingPlanInput.value === '') {
      submitButton.classList.add('not-click_disabled');
    } else if (submitButton) {
      submitButton.classList.remove('not-click_disabled');
    }
  }

  // Initial check
  toggleSubmitButton();

  // Use MutationObserver to monitor value changes for hidden input
  if (sellingPlanInput) {
    const observer = new MutationObserver(() => {
      toggleSubmitButton();
    });

    observer.observe(sellingPlanInput, {
      attributes: true,
      attributeFilter: ['value'], // Only observe changes to the 'value' attribute
    });
  }
});
